import styled from 'styled-components'

export const MonitorViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
